import React, { useState } from 'react';
import { BetslipContext } from '../data/betslip/BetslipConf';
import ReservationDetail from '../data/betslip/reservation-detail/ReservationDetail';
import ReservationDetailShareWh from '../data/betslip/reservation-detail/ReservationDetailShareWh';
import { getConfiguration } from '../data/utils';

function ReservationDetailPopup(props) {
    const betslipContext = React.useContext(BetslipContext);
    const [showReservationDetailsShare, setShowReservationDetailsShare] = useState(false)
    const conf = getConfiguration()

    if (betslipContext.showReservationDetail) {
        return (
            <div className="modal-container">
                {conf.iwh && showReservationDetailsShare ?
                    <ReservationDetailShareWh  onGoBack={()=> setShowReservationDetailsShare(false)} />
                    :
                    <ReservationDetail onGoShareLinkView={()=> setShowReservationDetailsShare(true)} />
                }
            </div>
        );
    }

    return null;
}

export default ReservationDetailPopup;